import {Mapper} from '@s-ui/domain'

export default class FromSchemaDataToSchemaValueObjectMapper extends Mapper {
  constructor({config}) {
    super()
    this._companyUrl = config.get('COMPANY_URL')
    this._hostNameDomain = config.get('HOST_NAME_DOMAIN')
    this._social = config.get('links')
    this._urlStatics = config.get('urlStatics')
  }

  _getSocialLinks = () => {
    const {social} = this._social
    return social.map(link => link.url)
  }

  map({context, type, logo, contactPoint: {contactPointType, contactType, url} = {}}) {
    return {
      '@context': context,
      '@type': type,
      name: this._hostNameDomain,
      url: this._companyUrl,
      logo: `${this._urlStatics}${logo}`,
      sameAs: this._getSocialLinks(),
      contactPoint: {
        '@type': contactPointType,
        contactType,
        url
      }
    }
  }
}
